<template lang="pug">
  - $image_path = '@/assets/images/rule/';
  .page-rule
    CloseButton
    transition(name="slidein" appear)
      .slide
        .page-title
          p.page-title-text: img(src=`${$image_path}title.png`)
          .page-title-decoration-white: img(src=`${$image_path}title_decoration_white.png`)
          .page-title-decoration-yellow: img(src=`${$image_path}title_decoration_yellow.png`)
        .swiper-container(ref="slider")
          .swiper-wrapper
            .swiper-slide: img(src=`${$image_path}image_001.png`)
            .swiper-slide: img(src=`${$image_path}image_002.png`)
            .swiper-slide
              router-link.button-start(
                :to="{ name:'game' }"
                @click.native="playSound('se_click_button')"
              )
                img(src=`${$image_path}button_start.png`)
              img(src=`${$image_path}image_003.png`)
          button.slide-control.next: img(src=`${$image_path}button_next.png`)
          button.slide-control.prev: img(src=`${$image_path}button_prev.png`)
          .slide-navi(ref="sliderNavi")
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

import SoundController from '@/assets/js/SoundController';

import CloseButton from '@/components/CloseButton';

export default {
  name: 'Rule',
  components: {
    CloseButton
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    imageList() {
      return ['image_001.png', 'image_002.png', 'image_003.png'];
    }
  },
  beforeDestroy() {
    SoundController.stopAll();
  },
  mounted() {
    SoundController.play('bgm_out_game');
    this.setupSlider();
  },
  methods: {
    setupSlider() {
      const swiper = new Swiper(this.$refs.slider, {
        effect: 'fade',
        noSwiping: false,
        loop: true,
        pagination: {
          el: this.$refs.sliderNavi,
          clickable: true,
          bulletClass: 'slide-navi-bullet',
          bulletActiveClass: 'active'
        },
        navigation: {
          nextEl: '.slide-control.next',
          prevEl: '.slide-control.prev'
        }
      });
      swiper.on('slideChange', () => {
        SoundController.play('se_move_page');
      });
    },
    playSound(key) {
      SoundController.play(key);
    }
  }
};
</script>

<style scoped lang="scss">
.page-rule {
  height: 100%;
  background: image-url('common/bg_castle_thin.png') no-repeat;
  background-size: 100% auto;
  .slide {
    height: 100%;
    .swiper-container {
      position: relative;
      height: 100%;
      &::before {
        display: block;
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 50%;
        background-color: #fff7d3;
      }
    }
    .page-title {
      top: vw(195);
      left: vw(211.5);
      width: vw(857);
      z-index: 2;
      &-decoration {
        &-white {
          top: vw(-10);
          left: vw(125);
          width: vw(650);
        }
        &-yellow {
          top: vw(-74);
          left: vw(46);
          width: vw(786);
        }
      }
    }
    &-control {
      position: absolute;
      top: vw(798);
      width: vw(96);
      z-index: 1;
      &.next {
        right: vw(35);
      }
      &.prev {
        left: vw(35);
      }
    }
    .button-start {
      position: absolute;
      top: vw(1468);
      left: vw(182);
      width: vw(916);
    }
    &-navi {
      position: absolute;
      top: vw(1760);
      left: 0;
      width: 100%;
      text-align: center;
      z-index: 1;
    }
  }
}

.slidefade-enter-active,
.slidefade-leave-active {
  transition: opacity 0.25s ease-in-out;
}
.slidefade-leave-to,
.slidefade-leave,
.slidefade-enter {
  opacity: 0;
}
.slidefade-enter-to {
  opacity: 1;
}
</style>

<style lang="scss">
.page-rule {
  .slide-navi-bullet {
    display: inline-block;
    width: vw(40);
    height: vw(40);
    margin-left: vw(45);
    border: vw(8) solid #e0d192;
    border-radius: 50%;
    background-color: #744400;
    outline: none;
    transition: background-color 0.25s ease-in-out;
    &:first-child {
      margin-left: 0;
    }
    &.active {
      background-color: #fff100;
    }
  }
}
</style>
